import { t } from 'i18next'
import * as React from 'react'
import { Trans } from 'react-i18next'
import { Link } from 'react-router-dom'
import { mk_widget, Widget } from 'widgets-for-react'

export const notfound_page: Widget<never> = mk_widget({
  run: o => (
    <header className="hero">
      <div className="block">
        <div className="hero__inner">
          <div className="breadcrumbs" typeof="BreadcrumbList" vocab="http://schema.org/">
            <span property="itemListElement" typeof="ListItem" className="breadcrumb">
              <a property="item" typeof="WebPage" href="/" className="link link--with-icon">
                <span property="name">Home</span>
                <svg className="breadcrumb__icon" width="6" height="8" aria-hidden="true">
                  <use xlinkHref="#icon--caret" />
                </svg>
                <meta property="position" content="1" />
              </a>
            </span>
            <span property="itemListElement" typeof="ListItem" className="breadcrumb">
              <span property="name">404</span>
              <meta property="position" content="2" />
            </span>
          </div>
          <h1 className="title--xl hero__title">{t('404.title')}</h1>
          <div className="hero__description text--styled">
            <Trans i18nKey="404.description">
              <Link to={t('404.link')}>homepage</Link>
            </Trans>
          </div>
        </div>
      </div>
    </header>
  )
})
